// Split date + time control replacing native <input type="datetime-local">,
// whose browser-owned popup can't be styled or kept open (close-and-reopen
// jank the owner flagged). Speaks the same "YYYY-MM-DDTHH:mm" value format,
// so it's a drop-in swap at every call site. Mirrors the New Meeting dialog's
// Date + Time pattern.
import React from 'react';
import { Input } from '@/features/shared/components/ui/input';

const pad = (n: number) => String(n).padStart(2, '0');
const todayStr = () => {
  const d = new Date();
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};

export const DateTimeField: React.FC<{
  value: string; // "YYYY-MM-DDTHH:mm" or ''
  onChange: (value: string) => void;
  /** Time used when a date is picked first (default 09:00). */
  defaultTime?: string;
  className?: string;
  inputClassName?: string;
  disabled?: boolean;
}> = ({ value, onChange, defaultTime = '09:00', className, inputClassName, disabled }) => {
  const [datePart, timePart] = (value || '').split('T');
  // Sizing lives on WRAPPER divs, never on the Inputs: the ui Input carries
  // w-full and cn() is plain clsx (no tailwind-merge), so a width utility on
  // the input itself loses to the base class unpredictably. min-w-0 keeps a
  // parent grid cell from pushing the row outside narrow dialogs.
  return (
    <div className={`flex gap-1.5 min-w-0 ${className || ''}`}>
      <div className="flex-1 min-w-0">
        <Input
          type="date"
          className={inputClassName}
          value={datePart || ''}
          disabled={disabled}
          onChange={(e) => {
            const d = e.target.value;
            onChange(d ? `${d}T${timePart || defaultTime}` : '');
          }}
        />
      </div>
      <div className="w-[108px] shrink-0">
        <Input
          type="time"
          className={inputClassName}
          value={timePart || ''}
          disabled={disabled}
          onChange={(e) => {
            const t = e.target.value;
            if (!t) return;
            onChange(`${datePart || todayStr()}T${t}`);
          }}
        />
      </div>
    </div>
  );
};

export default DateTimeField;
